export default {
  API_RESOURCE: 'task_lists',
  API_DISCUSSIONS_PATH: 'discussions'
}
